export const USER_ROLE = {
  ADMIN: "smartprint_smartprintadmin",
  READ_ONLY: "smartprint_smartprintro",
  READ_WRITE: "smartprint_smartprintrw",
};
